import React from 'react';

export default function InterviewHeader({
  companyName,
  jobTitle,
  completedCount,
  totalQuestions,
  progressPercent,
  activeTab,
  onTabChange,
  isManualVacancy,
}) {
  return (
    <div className="space-y-3">
      <section className="rounded-2xl border border-[#EFE7DF] bg-white px-4 py-3 shadow-sm">
        <div className="mb-2.5 flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="truncate text-[15px] font-bold text-[#2D2A26]">
              {companyName || 'Company'}
            </p>
            <p className="truncate text-xs font-medium text-[#8A8580]">
              {jobTitle || 'Interview'}
            </p>
          </div>
          <p className="shrink-0 text-xs font-semibold text-[#8A8580]">
            <span className="font-bold text-[#E8732A]">{completedCount}</span>/{totalQuestions} done
          </p>
        </div>

        <div className="flex items-center gap-2.5">
          <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-[#F2ECE5]">
            <div
              className="h-full rounded-full bg-gradient-to-r from-[#E8732A] to-[#F59E5E] transition-[width] duration-300 ease-out"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
          <span className="w-10 text-right text-xs font-bold text-[#E8732A]">
            {progressPercent}%
          </span>
        </div>
      </section>

      <section className="rounded-xl bg-[#EFE7DF] p-1">
        <div className="grid grid-cols-2 gap-1">
          <button
            type="button"
            onClick={() => onTabChange('chat')}
            className={`rounded-lg px-3 py-2 text-xs font-semibold transition ${
              activeTab === 'chat'
                ? 'bg-white text-[#E8732A] shadow-sm'
                : 'text-[#8A8580]'
            }`}
          >
            Interview
          </button>
          <button
            type="button"
            onClick={() => onTabChange('details')}
            className={`rounded-lg px-3 py-2 text-xs font-semibold transition ${
              activeTab === 'details'
                ? 'bg-white text-[#E8732A] shadow-sm'
                : 'text-[#8A8580]'
            }`}
          >
            {isManualVacancy ? 'Vacancy' : 'Job Details'}
          </button>
        </div>
      </section>
    </div>
  );
}
